/**
 * Validators for generic configuration fields
 */

// Individual validator functions for unit testing
export const validateEmail = (value) => {
  if (!value || typeof value !== "string" || value.trim() === "") {
    return "Please enter a valid email address";
  }

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value) ? null : "Please enter a valid email address";
};

export const validateNumeric = (value) => {
  // Handle null/undefined/empty values
  if (!value && value !== 0) {
    return "Please enter a valid number";
  }

  // If it's a number, check if it's an integer and positive
  if (typeof value === "number") {
    // Reject if it's not an integer (has decimal places)
    if (!Number.isInteger(value)) {
      return "Please enter a valid number";
    }
    // Reject if it's not positive (0 or negative)
    if (value <= 0) {
      return "Please enter a valid number";
    }
    // Valid positive integer
    return null;
  }

  // If it's not a string at this point, reject it
  if (typeof value !== "string") {
    return "Please enter a valid number";
  }

  // For strings, use the regex to validate
  const numericRegex = /^[1-9]\d*$/;
  return numericRegex.test(value) ? null : "Please enter a valid number";
};

export const genericConfigValidators = {
  administrator_destination_email: {
    required: true,
    validate: (value) => {
      if (!value || value.trim() === "") {
        return "This field is required";
      }
      return validateEmail(value) || false;
    },
  },
  points_expiration_in_days: {
    required: true,
    validate: (value) => {
      if (!Number(value)) {
        return "This field is required";
      }
      return validateNumeric(value) || false;
    },
  },
};
